module.exports = __webpack_public_path__ + "static/media/logo2.9d232a34.svg";